import React from "react"
import { Header } from "src/components/layout/header"
import { ReportTab } from "src/pages-lib/bonus-points/report-tab"

// Наши операции: что приложение отправило в Tillypad — начисления и списания по дням.
export default function BonusPoints() {
  return (
    <>
      <Header title="Баллы: наши операции" />
      <ReportTab source="sent" />
    </>
  )
}
